import { RiLeafLine } from "@remixicon/react";
import { Button } from "@earth-note/ui";

const HOME_URL = "https://earthnote.io";

/**
 * Shown when the add-in page is opened outside of Outlook (for example, directly
 * in a web browser). Instead of an error, we present a friendly, branded
 * information page so the URL always resolves to a functioning website.
 */
export function NotInOutlook() {
  return (
    <div className="flex h-full flex-col p-6">
      <div className="mb-6 flex justify-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
          <RiLeafLine className="h-8 w-8 text-green-600" />
        </div>
      </div>

      <div className="mb-6 text-center">
        <h2 className="text-title-h6 mb-2 font-semibold text-text-strong-950">Earth Note</h2>
        <p className="text-paragraph-sm text-text-sub-600">
          Earth Note is an add-in for Microsoft Outlook. It adds a climate-awareness GIF below your
          email signature, which you can toggle on or off for each email.
        </p>
        <p className="text-paragraph-sm mt-3 text-text-sub-600">
          To use it, open a new email in Outlook and select <strong>Earth Note</strong> from the
          ribbon. This page is the add-in&apos;s task pane and is designed to run inside Outlook.
        </p>
      </div>

      <div className="mt-auto">
        <a href={HOME_URL} target="_blank" rel="noopener noreferrer">
          <Button.Root className="w-full">Visit earthnote.io</Button.Root>
        </a>
      </div>

      <p className="mt-4 text-center text-paragraph-xs text-text-soft-400">
        Add climate awareness to your emails
      </p>
    </div>
  );
}
